module.exports = __webpack_public_path__ + "img/ruler.e01f54fb.svg";